import { apiClient } from '@/api/client';
import type { ProfileTaste } from '@/types/taste';
import { mapTasteResponseWireToDomain } from '../mappers/taste';
import { tasteResponseWireSchema, type TasteResponseWire } from '../schemas/taste';

/**
 * Domain-oriented API module for a user's aggregate taste signal.
 *
 * Backend contract (JWT-authenticated):
 *   GET /api/users/:id/taste
 *   -> { distribution: { not_for_me, okay, try_it, must_try }, total }
 */

/**
 * Fetch the taste distribution for a profile user.
 * Validates the wire response, then maps it to the domain {@link ProfileTaste}.
 */
export async function getUserTaste(userId: string): Promise<ProfileTaste> {
  const wire = await apiClient.get<TasteResponseWire>(`/api/users/${userId}/taste`);

  // Never trust the wire payload — validate at the boundary before mapping.
  const validated = tasteResponseWireSchema.parse(wire);
  return mapTasteResponseWireToDomain(validated);
}
